import React from 'react'
import { Result, Button } from 'antd'

export default class Page404 extends React.Component {
    render () {
        return (
            <Result
                status="404"
                title="404"
                subTitle={this.props.language["pageNotExist"]}
                extra={<Button onClick={() => this.props.history.push('/')} type="primary">{this.props.language["backHomepage"]}</Button>}
            />
        )
    }
}
